import React from 'react';
import clsx from 'clsx';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../../common/types';
import { ReelStatus } from '../../types';
import { reelStatusMessage } from './reelReviewMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the preview, the history and the sheets */
import styles from './ReelReview.module.scss';
/* eslint-enable css-modules/no-unused-class */

function pillClass(status: ReelStatus): string | undefined {
  switch (status) {
    case 'queued':
    case 'analysing':
    case 'planning':
    case 'rendering':
      return styles.pillWorking;
    case 'ready':
      return styles.pillReady;
    case 'approved':
      return styles.pillApproved;
    case 'rejected':
      return styles.pillRejected;
    case 'failed':
      return styles.pillFailed;
    default:
      // A status from a newer API: a grey pill, not a red one.
      return styles.pillNeutral;
  }
}

/**
 * The status pill of a reel (design c): amber with the stage name while it works, violet for
 * ready, green for approved, grey for rejected, red for failed. A status this app does not know
 * (from a newer API) gets a grey pill with a neutral label.
 */
const ReelStatusPillComponent: React.FC<{ status: ReelStatus }> = ({ status }) => {
  const intl = useIntl();
  return <span className={clsx(styles.pill, pillClass(status))}>{intl.formatMessage(reelStatusMessage(status))}</span>;
};

export const ReelStatusPill = TypedMemo(ReelStatusPillComponent);
